/**
 * Maps sidebar menu ids to RBAC module_key values (leaf modules only).
 * Parent groups use MENU_GROUP_CHILDREN for visibility.
 */

export const MENU_MODULE_MAP = {
  Dashboard: 'DASHBOARD',
  Orders: 'ORDERS',
  Stock: 'STOCK',
  Products: 'PRODUCTS',
  Designs: 'DESIGNS',
  Feeders: 'FEEDERS',
  Colors: 'COLORS',
  'Production Units': 'PRODUCTION_UNITS',
  Categories: 'CATEGORIES',
  'Sub Categories': 'SUB_CATEGORIES',
  Concepts: 'CONCEPTS',
  Settings: 'SETTINGS',
};

/** Parent sidebar id -> child menu ids (leaf items). */
export const MENU_GROUP_CHILDREN = {
  'Feeders & Colors': ['Feeders', 'Colors', 'Production Units'],
  'Category Insights': ['Categories', 'Sub Categories', 'Concepts'],
};

/** Entire sections visible only to OWNER_ADMIN (not module-granted). */
export const OWNER_ADMIN_ONLY_GROUPS = new Set(['Users', 'Permissions']);

/** Top-level menu ids only OWNER_ADMIN may see (not assignable via app roles). */
export const OWNER_ADMIN_ONLY_TOP_MENUS = new Set(['Dashboard']);

export const OWNER_ADMIN_ONLY_MENUS = new Set([
  'Admin User',
  'Brokers',
  'Parties',
  'Butta Cutting Parties',
  'Mill Finish Parties',
  'Border Cutting Parties',
  'Handwork Parties',
  'Transport parties',
  'Roles',
  'Assign Roles',
]);

/** pathname (no leading slash) -> menu id for route guards */
export const PATH_MENU_FOR_GUARD = {
  '': 'Dashboard',
  orders: 'Orders',
  stock: 'Stock',
  products: 'Products',
  designs: 'Designs',
  'masters/feeders': 'Feeders',
  'masters/colors': 'Colors',
  'masters/production-units': 'Production Units',
  'insights/categories': 'Categories',
  'insights/sub-categories': 'Sub Categories',
  'insights/concepts': 'Concepts',
  'users/admin': 'Admin User',
  'users/brokers': 'Brokers',
  'users/parties': 'Parties',
  'users/butta-cutting-parties': 'Butta Cutting Parties',
  'users/mill-finish-parties': 'Mill Finish Parties',
  'users/border-cutting-parties': 'Border Cutting Parties',
  'users/handwork-parties': 'Handwork Parties',
  'users/transport-parties': 'Transport parties',
  'security/roles': 'Roles',
  'security/assign-roles': 'Assign Roles',
  settings: 'Settings',
};

export function menuIdFromPathname(pathname) {
  const trimmed = pathname.replace(/\/+$/, '') || '/';
  const key = trimmed === '/' ? '' : trimmed.slice(1);
  return PATH_MENU_FOR_GUARD[key] || null;
}

export function isOwnerAdminOnlyMenu(menuId) {
  return (
    OWNER_ADMIN_ONLY_MENUS.has(menuId)
    || OWNER_ADMIN_ONLY_GROUPS.has(menuId)
    || OWNER_ADMIN_ONLY_TOP_MENUS.has(menuId)
  );
}
